const Dashboard_V4 = () => {
    return (
        <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M2 3.5C2 2.67 2.67 2 3.5 2H17.5C18.33 2 19 2.67 19 3.5V5H2V3.5ZM2 6V9H19V10H2V13H19V9.5V6H2ZM19 14H2V15.5C2 16.33 2.67 17 3.5 17H17.5C18.33 17 19 16.33 19 15.5V14ZM3.5 1C2.83696 1 2.20107 1.26339 1.73223 1.73223C1.26339 2.20107 1 2.83696 1 3.5L1 15.5C1 16.163 1.26339 16.7989 1.73223 17.2678C2.20107 17.7366 2.83696 18 3.5 18H17.5C18.163 18 18.7989 17.7366 19.2678 17.2678C19.7366 16.7989 20 16.163 20 15.5V3.5C20 2.83696 19.7366 2.20107 19.2678 1.73223C18.7989 1.26339 18.163 1 17.5 1L3.5 1Z" fill="currentColor"/>
        </svg>
    )
}

export default Dashboard_V4